import '@fontsource/playfair-display/400.css';
import '@fontsource/playfair-display/600.css';
import '@fontsource/playfair-display/700.css';
import '@fontsource/manrope/300.css';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { LanguageProvider } from './context/LanguageContext';
import HomePage from './pages/HomePage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import BookingPage from './pages/BookingPage';
import AdminPage from './pages/AdminPage';
import CalendarManagementPage from './pages/CalendarManagementPage';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <HashRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/property/:id" element={<PropertyDetailPage />} />
            <Route path="/booking/:propertyId" element={<BookingPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/calendar/:propertyId" element={<CalendarManagementPage />} />
          </Routes>
        </HashRouter>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;